import { createActionsWithPrefix } from "../../helperfunctions/action";

export const PaymentActions = createActionsWithPrefix("PAYMENT/", {
    GET_ISSUERS_REQUEST: "GET_ISSUERS_REQUEST",
    GET_ISSUERS_SUCCESS: "GET_ISSUERS_SUCCESS",
    GET_ISSUERS_ERROR: "GET_ISSUERS_ERROR",
});